var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCerca(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 11.5,
    rx: 12,
    ry: 11.5,
    fill: "#E7B05B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0166 21.3948C24.4992 19.3762 25.375 16.8841 25.375 14.1875C25.375 7.45653 19.9185 2 13.1875 2C6.45653 2 1 7.45653 1 14.1875C1 20.9185 6.45653 26.375 13.1875 26.375C15.8848 26.375 18.3775 25.4987 20.3964 24.0153L20.3948 24.0166C20.4501 24.0915 20.5117 24.1633 20.5796 24.2312L27.7992 31.4508C28.5314 32.1831 29.7186 32.1831 30.4508 31.4508C31.1831 30.7186 31.1831 29.5314 30.4508 28.7992L23.2312 21.5796C23.1633 21.5117 23.0915 21.4501 23.0166 21.3948ZM23.5 14.1875C23.5 19.8829 18.8829 24.5 13.1875 24.5C7.49206 24.5 2.875 19.8829 2.875 14.1875C2.875 8.49206 7.49206 3.875 13.1875 3.875C18.8829 3.875 23.5 8.49206 23.5 14.1875Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerca);
export default __webpack_public_path__ + "static/media/Cerca.ce8c7a9f13d2564c631050ee08bcacbe.svg";
export { ForwardRef as ReactComponent };